import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './layout.scss';
import Navbar from './Navbar/Navbar';
// import MenuHeader from './MenuHeader';
const AppLayout = () => {
  return (
    <div className="app-layout">
      <Header />
      <Navbar />
      <main className="app-main container-fluid">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;
